import LoginView from "components/layout/login-view";

const UserInvitationSignicatAbortView = () => {
  return (
    <LoginView title="Kirjautuminen epäonnistui" transition={false}>
      Kirjautuminen epäonnistui. Kokeile uudestaan hetken kuluttua!
      <br />
      <br />
      Virheen toistuessa ota yhteyttä organisaatiosi ylläpitäjään.
    </LoginView>
  );
};

export default UserInvitationSignicatAbortView;
